module.exports = __webpack_public_path__ + "img/facility4.11c788a9.png";